import { Table, Col, Card, Space, Typography, Radio, Modal, Spin} from "antd"
import { ToolTypes, updateToolSettings,identifyTool as identifyToolAPI, clearData,getToolSettings,fwStatus,
        fwUpdate,removeTool,getSenderShares,checkRecipientEmail,addShare as addShareAPI,getRecipientShares,deleteRecipientShare } from "../../API";
import { Row, Text, View, Icon, Graph, Alert, Button} from "../../Components"
import { Metrics, Helpers, Colors,Spacing,channelColors,Fonts,toolSyncTime,otaStates,Images,sensorLive } from '../../global'
import HelperService from '../../Helpers/HelperService'
import {
    ArrowLeftOutlined
} from "@ant-design/icons"
import { Auth } from 'aws-amplify'
import { useEffect, useState, useRef } from "react"
import { useRecoilState } from "recoil"
import { allSitesAtom } from "../../Atoms/allSitesAtom"
import { useAuthenticator } from '@aws-amplify/ui-react'
import { useMatch } from 'react-router-dom'
import { useNavigate } from "react-router-dom"
import { THP, SA4C, ST4C, SSS1, SCP1, SDP1 } from '../../Tools'
import { THP_CHANNEL_ICONS,THP_CH_ENUM,THPChannelContainer } from '../../Tools/THP'
import { SDP1_CHANNEL_ICONS,SDP1_CH_ENUM,SDP1ChannelContainer } from '../../Tools/SDP1'
import { ST4C_CHANNEL_ICONS,ST4C_CH_ENUM,ST4CChannelContainer } from '../../Tools/ST4C'
import { SA4C_CHANNEL_ICONS,SA4C_CH_ENUM,SA4CChannelContainer  } from '../../Tools/SA4C'
import { SSS1_CHANNEL_ICONS,SSS1_CH_ENUM,SSS1ChannelContainer  } from '../../Tools/SSS1'
import { SCP1_CHANNEL_ICONS,SCP1_CHANNEL_ARRAY,SCP1ChannelContainer  } from '../../Tools/SCP1'
import { ReactComponent as PostFreqIcon} from '../../Assets/SVG/Stratus_PostFreq.svg'
import { ReactComponent as AcqPeriodIcon} from '../../Assets/SVG/Stratus_AcqPeriod.svg'
import { ReactComponent as toolIcon} from '../../Assets/SVG/Tool_Small.svg'
import { ReactComponent as infoIcon} from '../../Assets/SVG/Info.svg'
import { ReactComponent as wifiIcon} from '../../Assets/SVG/Wifi_Small.svg'
// import { ActionSheetCustom as ActionSheet } from 'react-native-actionsheet'
import { ReactComponent as toolInIcon} from '../../Assets/SVG/ToolIn_Small.svg'
import { ReactComponent as toolOutIcon} from '../../Assets/SVG/ToolOut_Small.svg'
import { ReactComponent as firmwareIcon} from '../../Assets/SVG/Firmware_Small.svg'
import { ReactComponent as clearIcon} from '../../Assets/SVG/Clear_Small.svg'
import { ReactComponent as deleteIcon} from '../../Assets/SVG/Trash_Small.svg'
import { ReactComponent as logIcon} from '../../Assets/SVG/LogEnable_Small.svg'
import { ReactComponent as shareIcon} from '../../Assets/SVG/Share.svg'
import { ReactComponent as identifyIcon} from '../../Assets/SVG/IdentifyTool.svg'
import { ReactComponent as selectedIcon} from '../../Assets/SVG/RadioSelected.svg'
import { ReactComponent as unselectedIcon} from '../../Assets/SVG/RadioUnselected.svg'
import { ReactComponent as troubleshootIcon} from '../../Assets/SVG/Troubleshoot_Small.svg'
import { ReactComponent as analogIcon} from '../../Assets/SVG/Analog_Small.svg'
import { ReactComponent as therm4Icon} from '../../Assets/SVG/4Ch_Small.svg'
import { ReactComponent as chemIcon} from '../../Assets/SVG/ChemSense_Small.svg'
import { ReactComponent as swimIcon} from '../../Assets/SVG/SwimSense_Small.svg' 
import { ReactComponent as thpIcon} from '../../Assets/SVG/THP_Small.svg'
import { ReactComponent as addIcon} from '../../Assets/SVG/AddTool_Small.svg'
import { ReactComponent as userSmallIcon} from '../../Assets/SVG/User_Small.svg'
import { ReactComponent as appearanceIcon} from '../../Assets/SVG/Appearance_Small.svg'
import { ReactComponent as emailIcon} from '../../Assets/SVG/Email.svg'
import { ReactComponent as phoneIcon} from '../../Assets/SVG/Phone.svg'
import { ReactComponent as passIcon} from '../../Assets/SVG/Password.svg'
import { ReactComponent as newsIcon} from '../../Assets/SVG/Newsletter.svg'
import { ReactComponent as signOutIcon} from '../../Assets/SVG/SignOut.svg'
import { ReactComponent as userIcon} from '../../Assets/SVG/User.svg'
import { ReactComponent as battery100Icon} from '../../Assets/SVG/Battery100.svg'
import { ReactComponent as battery80Icon} from '../../Assets/SVG/Battery80.svg'
import { ReactComponent as battery60Icon} from '../../Assets/SVG/Battery60.svg'
import { ReactComponent as battery40Icon} from '../../Assets/SVG/Battery40.svg'
import { ReactComponent as battery20Icon} from '../../Assets/SVG/Battery20.svg'
import { ReactComponent as battery10Icon} from '../../Assets/SVG/Battery10.svg'
import { ReactComponent as batteryLowIcon} from '../../Assets/SVG/BatteryLow.svg'
import { ReactComponent as locationIcon} from '../../Assets/SVG/Location_Small.svg'
import { ReactComponent as powerIcon} from '../../Assets/SVG/USBPowered.svg'
import { ReactComponent as updateIcon} from '../../Assets/SVG/Update.svg'
import { ReactComponent as userAddIcon} from '../../Assets/SVG/AddUser.svg'
import _ from 'lodash'
// import "./ToolSettings.css"
import Settings from "../Settings";
import PhoneInput from 'react-phone-number-input'
import 'react-phone-number-input/style.css'

const styles = {
    container: {
      flex: 1,
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      marginTop:Spacing.md,
    },
    symbolContainer: {
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'flex-start',
      marginTop:Spacing.md + Spacing.xm,
      ...Metrics.horizontalMargin
    },
  }

let goingToFirmware = false

let content1 = <></>
let content2 = <></>
let content3 = <></>
let mac
let graphMac
let channel
let tool


function ToolSettings() {
  const matchGraphMac = useMatch('/site/:mac')
  const matchMac = useMatch('/toolSettings/:mac')
  const matchChannel = useMatch('/toolSettings/:mac/channel/:key')
  const matchShare = useMatch('/toolSettings/:mac/sharePage')
  const matchShareMember = useMatch('/toolSettings/:mac/addMember')
  const matchGeneral = useMatch('/toolSettings/:mac/general')
  const matchNetwork = useMatch('/toolSettings/:mac/network')
  const matchFirmware = useMatch('/toolSettings/:mac/firmware')
  const [graphPage, setGraphPage] = useState('')
  
  console.log('Path:',window?.location?.pathname)
  if(window?.location?.pathname.includes('site')){
    graphMac = matchGraphMac?.params?.mac;
    mac = graphMac
    console.log('SubPAGE: share')
    console.log('toolSettings mac:',mac)
    if(graphPage.includes('channel')){
      channel = graphPage.slice(8)
    }else{
      channel = false
    }
  } else{
      graphMac = undefined
      if(window?.location?.pathname.includes('sharePage')){
          mac = matchShare?.params?.mac;
          if(mac){
              channel = false
          } 
          console.log('SubPAGE: share')
          console.log('toolSettings mac:',mac)
      }else if(window?.location?.pathname.includes('addMember')){
          mac = matchShareMember?.params?.mac;
          if(mac){
              channel = false
          } 
          console.log('SubPAGE: addMember')
          console.log('toolSettings mac:',mac)
      }else if(window?.location?.pathname.includes('general')){
          mac = matchGeneral?.params?.mac;
          if(mac){
              channel = false
          } 
          console.log('SubPAGE: general')
          console.log('toolSettings mac:',mac)
      }else if(window?.location?.pathname.includes('network')){
          mac = matchNetwork?.params?.mac;
          if(mac){
              channel = false
          } 
          console.log('SubPAGE: network')
          console.log('toolSettings mac:',mac)
      }else if(window?.location?.pathname.includes('firmware')){
          mac = matchFirmware?.params?.mac;
          if(mac){
              channel = false
          } 
          console.log('SubPAGE: firmware')
          console.log('toolSettings mac:',mac)
      }else if(window?.location?.pathname.includes('channel')){
          mac = matchChannel?.params?.mac;
          console.log('channel:',matchChannel?.params?.key)
          console.log('last channel:',channel)
          if(mac && !_.isEqual(matchChannel?.params?.key,channel)){
              console.log('CHANNEL DIFFERENT THAN PREVIOUS')
              channel = matchChannel?.params?.key;
          }         
          
          console.log('SubPAGE: channel')
          console.log('toolSettings mac:',mac)
          console.log('toolSettings channel:',channel)
      }else{
          mac = matchMac?.params?.mac;
          channel = false
      }
    }
    const { user, signOut } = useAuthenticator((context) => [context.user]);
    const [allSites, setAllSites] = useRecoilState(allSitesAtom)
    const [dbUser, setDbUser] = useState(allSites.user)
    tool = allSites[mac]
//   const recipientShares = useSelector((state) => getRecipientShares(state))
//   const recipent = !_.isEmpty(recipientShares) && recipientShares.get(tool.share_id)?recipientShares.get(tool.share_id):null
const [senderShares, setSenderShares] = useState(null)
const [recipientShares, setRecipientShares] = useState(allSites['recipientShares'])
console.log('AllSites Tool Settings:',allSites)
  console.log("Tool:", tool)
//   const toolStatus = useSelector((state) => getStatus(state))
  const channels = !_.isEmpty(tool)?tool?.settings?.channels:[]
  const [deleteTool, setDeleteTool] = useState(false)
  const [deleteToolLoading, setDeleteToolLoading] = useState(false)
  const [deleteInitiated, setDeleteInitiated] = useState(false)
  const [removeSharedTool, setRemoveSharedTool] = useState(false)
  const [clearTool, setClearTool] = useState(false)
  const [clearToolLoading, setClearToolLoading] = useState(false)
  const [clearToolStatus, setClearToolStatus] = useState('')
  const [logEnable, setLogEnable] = useState(!_.isEmpty(tool)?(tool?.settings?.controls?.sysLogEnable):0)
  const [logEnableTool, setLogEnableTool] = useState(!_.isEmpty(tool) && !_.isEmpty(tool?.toolSettings)?(tool?.toolSettings?.controls?.sysLogEnable):0)
  const [logEnableTime, setLogEnableTime] = useState(true)
  const [usbPostFreq, setUsbPostFreq] = useState(!_.isEmpty(tool) && tool?.settings?.controls?.sysUSBPostFreq?(tool?.settings?.controls?.sysUSBPostFreq).toFixed(0):0)
  const [usbPostFreqTool, setUsbPostFreqTool] = useState(!_.isEmpty(tool) && !_.isEmpty(tool?.toolSettings) && tool?.toolSettings?.controls?.sysUSBPostFreq?(tool?.toolSettings?.controls?.sysUSBPostFreq).toFixed(0):0)
  const [usbPostFreqTime, setUsbPostFreqTime] = useState(true)
  const [usbAcqPer, setUsbAcqPer] = useState(!_.isEmpty(tool) && tool?.settings?.controls?.sysUSBAcqPer?(tool?.settings?.controls?.sysUSBAcqPer).toFixed(0):0)
  const [usbAcqPerTool, setUsbAcqPerTool] = useState(!_.isEmpty(tool) && !_.isEmpty(tool?.toolSettings) && tool?.toolSettings?.controls?.sysUSBAcqPer?(tool?.toolSettings?.controls?.sysUSBAcqPer).toFixed(0):0)
  const [usbAcqPerTime, setUsbAcqPerTime] = useState(true)
  const [customPost,setCustomPost] = useState(false)
  const [customPostVal,setCustomPostVal] = useState(usbPostFreq)
  const [postMode,setPostMode] = useState(getPostMode(usbPostFreq))
  const [postPicker,showPostPicker] = useState(false)
  const [customAcq,setCustomAcq] = useState(false)
  const [customAcqVal,setCustomAcqVal] = useState(usbAcqPer/60)
  const [value,setValue] = useState("0")
  const [valueUpdated,setValueUpdated] = useState(false)
  const [acqMode,setAcqMode] = useState(getAcqMode(usbAcqPer))
  const [acqPicker,showAcqPicker] = useState(false)
  const [share,setShare] = useState(true)
  const [identifyTool, setIdentifyTool] = useState(false)
  const [identifyToolLoading, setIdentifyToolLoading] = useState(false)
  const [identifyToolStatus, setIdentifyToolStatus] = useState('')
  const [refreshing, setRefreshing] = useState(false)
  const [toolLocation, setToolLocation] = useState(tool?.settings?.toolLocation)
  const [toolName, setToolName] = useState(tool?.settings?.toolName)
//   const recipientShares = useSelector((state) => getRecipientShares(state))
//   console.log('recipientShares:',recipientShares)
  // const [batPostFreq, setBatPostFreq] = useState((tool.settings.controls.sysBatPostFreq).toFixed(0))
  // const [batAcqPer, setBatAcqPer] = useState((tool.settings.controls.sysBattAcqPer).toFixed(0))
  const type = tool?.toolType
  const batteryLvl = tool?.toolSystem?.sysBatteryLvl
  const powerSrc = tool?.toolSystem?.sysPowerState
  const ip = tool?.toolSystem?.wifiIpAddr
  const ssid = tool?.toolSystem?.wifiSSID
  const [latestVersion, setLatestVersion] = useState("")
  const [releaseNotes,setReleaseNotes] = useState("")
//   const devMode = useSelector((state) => getDevMode(state))
  const [fwVer, setFwVer] = useState(tool?.toolSystem?.sysFwVer)
  const [otaState, setOtaState] = useState((_.has(tool?.toolSystem,"ota") && tool?.toolSystem?.ota != null)?tool?.toolSystem?.ota?.state:"No OTA Status")
  const [otaError, setOtaError] = useState((_.has(tool?.toolSystem,"ota") && tool?.toolSystem?.ota != null)?tool?.toolSystem?.ota?.error:"")
  console.log('OTA State:',otaState)
  console.log('OTA Error:',otaError)
  const [updating, setUpdating] = useState(otaState == "No OTA Status" || otaState == undefined?false:true)
  const [progress, setProgress] = useState(0)
  const [updateButtonLoading, setUpdateButtonLoading] = useState(false)
  const [startUpdateStatus, setStartUpdateStatus] = useState('ok')
  const [monitorToolSettings, setMonitorToolSettings] = useState(false)
  const userEmail = user?.attributes?.email
  const [emailError, setEmailError] = useState('')
  const [email, setEmail] = useState('')
  const [error,setError] = useState('')
  const [verifyButtonLoading, setVerifyButtonLoading] = useState(false)
  const [addShare, setAddShare] = useState(false)
  const [addInitiated, setAddInitiated] = useState(false)
  const [addLoading, setAddLoading] = useState(false)
  const [addStatus, setAddStatus] = useState('')
  const [verified, setVerified] = useState(false)
  const [verifyInitiated, setVerifyInitiated] = useState(false)

  let channelIcon
  let channelArray 
  if(tool?.toolType){
    if(!ToolTypes.THP.localeCompare(tool.toolType)){
        channelArray=[[THP_CH_ENUM[0],_.get(channels,THP_CH_ENUM[0])],[THP_CH_ENUM[1],_.get(channels,THP_CH_ENUM[1])],[THP_CH_ENUM[2],_.get(channels,THP_CH_ENUM[2])],[THP_CH_ENUM[3],_.get(channels,THP_CH_ENUM[3])],[THP_CH_ENUM[4],_.get(channels,THP_CH_ENUM[4])]]
      }else if(!ToolTypes.SDP.localeCompare(tool.toolType)){
        channelArray=[[SDP1_CH_ENUM[0],_.get(channels,SDP1_CH_ENUM[0])],[SDP1_CH_ENUM[1],_.get(channels,SDP1_CH_ENUM[1])],[SDP1_CH_ENUM[2],_.get(channels,SDP1_CH_ENUM[2])],[SDP1_CH_ENUM[3],_.get(channels,SDP1_CH_ENUM[3])],[SDP1_CH_ENUM[4],_.get(channels,SDP1_CH_ENUM[4])],[SDP1_CH_ENUM[5],_.get(channels,SDP1_CH_ENUM[5])]]
      }else if(!ToolTypes.THERMO_4_CH.localeCompare(tool.toolType)){
        channelArray=[[ST4C_CH_ENUM[0],_.get(channels,ST4C_CH_ENUM[0])],[ST4C_CH_ENUM[1],_.get(channels,ST4C_CH_ENUM[1])],[ST4C_CH_ENUM[2],_.get(channels,ST4C_CH_ENUM[2])],[ST4C_CH_ENUM[3],_.get(channels,ST4C_CH_ENUM[3])],[ST4C_CH_ENUM[4],_.get(channels,ST4C_CH_ENUM[4])]]
      }else if(!ToolTypes.ANALOG_4_CH.localeCompare(tool.toolType)){
        channelArray=[[SA4C_CH_ENUM[0],_.get(channels,SA4C_CH_ENUM[0])],[SA4C_CH_ENUM[1],_.get(channels,SA4C_CH_ENUM[1])],[SA4C_CH_ENUM[2],_.get(channels,SA4C_CH_ENUM[2])],[SA4C_CH_ENUM[3],_.get(channels,SA4C_CH_ENUM[3])]]
      }else if(!ToolTypes.SWIM.localeCompare(tool.toolType)){
        channelArray=[[SSS1_CH_ENUM[0],_.get(channels,SSS1_CH_ENUM[0])],[SSS1_CH_ENUM[1],_.get(channels,SSS1_CH_ENUM[1])],[SSS1_CH_ENUM[2],_.get(channels,SSS1_CH_ENUM[2])],[SSS1_CH_ENUM[3],_.get(channels,SSS1_CH_ENUM[3])],[SSS1_CH_ENUM[4],_.get(channels,SSS1_CH_ENUM[4])],[SSS1_CH_ENUM[5],_.get(channels,SSS1_CH_ENUM[5])],[SSS1_CH_ENUM[6],_.get(channels,SSS1_CH_ENUM[6])]]
      }else if(!ToolTypes.CHEM.localeCompare(tool.toolType)){
        channelArray = SCP1_CHANNEL_ARRAY(tool,channels)
      }else{
        console.warn("UNDEFINED TOOLTYPE")
      }
  }
  
  console.log('Channel Array:',channelArray)

    const navigate = useNavigate();
    let postOptions = ['1 Acquisition','10 Acquisitions','30 Acquisitions','50 Acquisitions', 'Custom ']
    let postOptionValues = [1,10,30,50]
    let acqOptions = ['Every 1 min','Every 10 mins','Every 30 mins','Every 1 hr', 'Custom ']
    let acqOptionValues = [60,600,1800,3600]
    function errorCheck(){
        let errorsFound = false
        if(email==''){
            errorsFound = true
            setEmailError("Required")
        }
        if(errorsFound){
            return false
        }
        return true      
    }
    function updateEmail(email) {
        setEmail(email)
        setEmailError('')
        setVerifyInitiated(false)
        setVerified(false)
    }
    function updateSettings(object) {
        console.log('updated Settings:',object)
        updateToolSettings( tool, object)
    }
    async function getSettings() {
        console.log('update Settings')
        let settings = await getToolSettings(tool).then((settings) => settings)
        console.log('Tool Settings Settings:',settings)
        let tempAllSites = _.cloneDeepWith(allSites)
        tempAllSites[mac].settings = settings.settings
        tempAllSites[mac].toolSettings = settings.toolSettings
        tempAllSites[mac].toolSystem = settings.toolSystem
        console.log('getSettings Updating AllSites to ',tempAllSites)
        setAllSites(tempAllSites)
    }

    function getPostMode(object) {
        console.log('Get Post Mode Object:',object)
        switch (object) {
          case '1':
            return 0
          case '10':
            return 1
          case '30':
            return 2
          case '50':
            return 3
          default://Custom
            return 4
        }
      }
    
      function getAcqMode(object) {
        console.log('Get Acq Mode Object:',object)
        switch (object) {
          case '60':
            return 0
          case '600':
            return 1
          case '1800':
            return 2
          case '3600':
            return 3
          default://Custom
            return 4
        }
      }
      const pullSenderShares = async ()=>{
        if(user.signInUserSession.idToken.jwtToken){
            let senderShares = await getSenderShares({token:user.signInUserSession.idToken.jwtToken}).then(data => {
                console.log('data:',data)
                return data
            })
            console.log('Sender Shares:',senderShares)
            setSenderShares(senderShares)
        }
      }
      //
      //
      //
      //
      useEffect(() => {
        const intervalId = setInterval(async () => {
          if (monitorToolSettings) {
            getSettings()
          }
        }, 5000);
      
        return () => clearInterval(intervalId); // Clear the interval when the component is unmounted.
      }, [monitorToolSettings, mac]);
      useEffect(() => {
          console.log('useFocusEffect recipient')
          if(mac){
            // dispatch(ToolActions.getRecipientShares())
            if(recipientShares == null || !_.has(recipientShares,mac) || recipientShares.get(mac).recipientSettings.acceptState == false){
              setShare(false)
            }
          }
        }, [recipientShares])
    
        useEffect(() => {
            console.log('useEffect addStatus')
            if(addStatus == '' && addLoading){
              //Nothing
            }else{
              setAddLoading(false)
            }
        }, [addStatus,setAddLoading]);
        useEffect(() => {
            console.log("USE EFFECT. addLoading:",addLoading,"addInitiated",addInitiated)
            const shareTool = async ()=>{
                if(addLoading){
                    try {
                    if(_.has(tool,'mac')){
                        let response = await addShareAPI(user.signInUserSession.idToken.jwtToken,tool.mac, email)
                        console.log('addShare response:')
                        setAddStatus(response)
                        setAddShare(true)
                    }
                    } catch (error) {
                    console.log("addShare ERROR:", error)
                    }
                }
            }
            shareTool()
            // else{
            //   if(deleteInitiated) NavigationService.navigateAndReset('Dashboard')
            // }
        }, [addLoading,addInitiated]);
    //   useEffect(() => {
    //       console.log('useFocusEffect monitor')
    //       if(!_.isEmpty(tool) && user.signInUserSession.idToken.jwtToken){
    //         getSettings()
    //       }
    //       return () => {
    //         clearTimeout(timer0.current)
    //         timer0.current = null
    //         clearTimeout(timer1.current)
    //         timer1.current = null
    //         clearTimeout(timer2.current)
    //         timer2.current = null
    //       }
    //     }, [user])
      
      useEffect(() => {
        //Rerender
        console.log('useEffect value')
        setValueUpdated(false)
      }, [value]);

      useEffect(() => {
        console.log('useEffect deleteLoading')
        const deleteToolFromAccount = async () =>{
            if(deleteToolLoading){
                try {
                  setMonitorToolSettings(false)
                  if(tool.mac){
                    let response = await removeTool(user.signInUserSession.idToken.jwtToken,mac).then((result)=>result)
                    console.log('Response:',response)
                    if(response == true){
                      let tempAllSites = _.cloneDeep(allSites)
                      tempAllSites['repull'] = true
                      console.log('deleteToolFromAccount Updating AllSites to ',tempAllSites)
                      setAllSites(tempAllSites)
                      navigate(`/settings`)
                    }
                  }else{
                    let response = await deleteRecipientShare(user.signInUserSession.idToken.jwtToken,mac).then((result)=>result)
                    console.log('Response:',response)
                    if(response == true){
                      let tempAllSites = _.cloneDeep(allSites)
                      tempAllSites['repull'] = true
                      console.log('deleteToolFromAccount Updating AllSites to ',tempAllSites)
                      setAllSites(tempAllSites)
                      navigate(`/settings`)
                    }
                  }
                } catch (error) {
                  console.log("DELETE ERROR:", error)
                }
              }
        }
        deleteToolFromAccount()
      }, [deleteToolLoading,deleteInitiated]);

    useEffect(() => {
        console.log('useEffect clearToolStatus')
        if(clearToolStatus == '' && clearToolLoading){
          //Nothing
        }else{
          setClearToolLoading(false)
        }
    }, [clearToolStatus,setClearToolLoading]);
      useEffect(() => {
        console.log('useEffect identifyLoading')
        if(clearToolLoading){
          try {
            let tempResponse = ''
            if(tool.mac){
                tempResponse = clearData(user.signInUserSession.idToken.jwtToken,{ mac: mac })
            }else{
                tempResponse = clearData(user.signInUserSession.idToken.jwtToken,{ share_id: mac })
            }
            setClearToolStatus(tempResponse)
          } catch (error) {
            console.log("CLEAR ERROR:", error)
          }
        }else{
          setClearTool(false)
        }
      }, [clearToolLoading]);
    useEffect(() => {
        console.log('useEffect identifyToolStatus')
        if(identifyToolStatus == '' && identifyToolLoading){
          //Nothing
        }else{
          setIdentifyToolLoading(false)
        }
    }, [identifyToolStatus,setIdentifyToolLoading]);
      useEffect(() => {
        console.log('useEffect identifyLoading')
        if(identifyToolLoading){
          try {
            let tempResponse = ''
            if(tool.mac){
                tempResponse = identifyToolAPI(user.signInUserSession.idToken.jwtToken,{ mac: mac })
            }else{
                tempResponse = identifyToolAPI(user.signInUserSession.idToken.jwtToken,{ share_id: mac })
            }
            setIdentifyToolStatus(tempResponse)
          } catch (error) {
            console.log("CLEAR ERROR:", error)
          }
        }else{
          setIdentifyTool(false)
        }
      }, [identifyToolLoading]);
    
      useEffect(() => {
        setLogEnable(!_.isEmpty(tool)?(tool.settings.controls.sysLogEnable):0)
        setLogEnableTool(!_.isEmpty(tool) && !_.isEmpty(tool.toolSettings)?(tool.toolSettings.controls.sysLogEnable):0)
        setUsbPostFreq(!_.isEmpty(tool)?(tool.settings.controls.sysUSBPostFreq).toFixed(0):0)
        setUsbPostFreqTool(!_.isEmpty(tool) && !_.isEmpty(tool.toolSettings)?(tool.toolSettings.controls.sysUSBPostFreq).toFixed(0):0)
        setUsbAcqPer(!_.isEmpty(tool)?(tool.settings.controls.sysUSBAcqPer).toFixed(0):0)
        setUsbAcqPerTool(!_.isEmpty(tool) && !_.isEmpty(tool.toolSettings)?(tool.toolSettings.controls.sysUSBAcqPer).toFixed(0):0)
        setPostMode(getPostMode(!_.isEmpty(tool)?(tool.settings.controls.sysUSBPostFreq).toFixed(0):0))
        setAcqMode(getAcqMode(!_.isEmpty(tool)?(tool.settings.controls.sysUSBAcqPer).toFixed(0):0))
        setToolName(tool?.settings?.toolName)
      }, [tool]);
      useEffect(() => {
        console.log('ALL SITES UPDATED ON TOOL SETTINGS PAGE')
        tool = allSites[mac]
        setRecipientShares(allSites['recipientShares'])
      }, [allSites]);

      useEffect(() => {
          async function fetchData() {
            let status = await fwStatus(user.signInUserSession.idToken.jwtToken,mac).then((status)=>status)
            console.log('FIRMWARE STATUS:',status)
            setLatestVersion(status?.latestVersion)
            setReleaseNotes(status?.releaseNotes)
          }
          
          
            
          if(window?.location?.pathname.includes('firmware')){
            setMonitorToolSettings(true)
            fetchData();
          }else{
            setMonitorToolSettings(false)
          }
          if(window?.location?.pathname.includes('sharePage')){
            pullSenderShares()
          }
          if(window?.location?.pathname.includes('addMember')){
            setVerifyButtonLoading(false)
            setAddShare(false)
            setAddInitiated(false)
            setAddLoading(false)
            setAddStatus('')
            setVerified(false)
            setVerifyInitiated(false)
          }
        }, [window?.location?.pathname])
      
      
      useEffect(() => {
        console.log("tool system updated on firmware page")
        if(tool?.toolSystem){
            let tempState = (_.has(tool.toolSystem,"ota") && tool.toolSystem.ota != null)?tool.toolSystem.ota.state:"No OTA Status"
            let tempError = (_.has(tool.toolSystem,"ota") && _.has(tool.toolSystem.ota,"error") && tool.toolSystem.ota != null)?tool.toolSystem.ota.error:""
            setFwVer(tool.toolSystem.sysFwVer)
            setOtaState(tempState)
            setOtaError(tempError)
            switch (tempState) {
            case otaStates.STARTED:
                setProgress(1)
                break;
            case otaStates.CREATE_AWS_URL:
                setProgress(10)
                break;
            case otaStates.CONNECT_AWS:
                setProgress(20)
                break;
            case otaStates.GET_CONTENT_LEN:
                setProgress(30)
                break;
            case otaStates.DOWNLOADING:
                setProgress(40)
                break;
            case otaStates.DOWNLOAD_COMPLETE:
                setProgress(50)
                break;
            case otaStates.GET_PARTITION:
                setProgress(60)
                break;
            case otaStates.ERASING_PARTITION:
                setProgress(70)
                break;
            case otaStates.WRITE_APP_IMAGE:
                setProgress(80)
                break;
            case otaStates.VERIFY_PARTITION:
                setProgress(85)
                break;
            case otaStates.SET_PARTITION:
                setProgress(90)
                break;
            case otaStates.RESTARTING:
                setProgress(99)
                break;
            default:
                break;
            }
            if((tool.toolSystem.sysFwVer == latestVersion || tempError != "") && updating){
                console.log("CHANGING UPDATING. VERSION:",tool.toolSystem.sysFwVer,"LATEST VERSION:",latestVersion, "ERROR:",tempError)
                setUpdating(false)
            } 
        }
        
      }, [tool?.toolSystem])
  
      useEffect(() => {
        if(startUpdateStatus == 'inProgress'){
          setUpdateButtonLoading(true)
        }else{
          setUpdateButtonLoading(false)
        }
      }, [startUpdateStatus]);
  
      useEffect(() => {
        const startUpdate = async () =>{
            console.log('Update Started')
          setProgress(0)
          setUpdating(true)
          let tempStatus = await fwUpdate(user.signInUserSession.idToken.jwtToken, mac,latestVersion)
          if(_.has(tempStatus,'errors')){
            setStartUpdateStatus('error: '+ tempStatus.errors)
          }else{
            setStartUpdateStatus('ok')
          }
        }
        if(updateButtonLoading){
          try {
            startUpdate()
          } catch (error) {
            console.log("UPDATE ERROR:", error)
          }
        }
    }, [updateButtonLoading]);
      ///
      ///
      ///

    const timer0 = useRef(null)
    const timer1 = useRef(null)
    const timer2 = useRef(null)
    async function updateLogEnableTime() {
        clearTimeout(timer0.current)
        timer0.current = null
        setLogEnableTime(false)
        timer0.current = setTimeout(async() => {
          getSettings()
          await HelperService.delayMs(1000)
          setLogEnableTime(true)
        }, toolSyncTime-1000)
    }
    async function updateUsbPostFreq() {
        clearTimeout(timer1.current)
        timer1.current = null
        setUsbPostFreqTime(false)
        timer1.current = setTimeout(async() => {
          getSettings()
          await HelperService.delayMs(1000)
          setUsbPostFreqTime(true)
        }, toolSyncTime-1000)
    }
    async function updateUsbAcqPer() {
        clearTimeout(timer2.current)
        timer2.current = null
        setUsbAcqPerTime(false)
        timer2.current = setTimeout(async() => {
          getSettings()
          await HelperService.delayMs(1000)
          setUsbAcqPerTime(true)
        }, toolSyncTime-1000)
    }
    
    if(allSites.tools){
        content1 = (
            <View style={{display:'flex',flexDirection: 'column',height:'100%',flex:1,overflow:'auto'}}>
                {graphMac?<></>:<View style={{overflow:'none'}}>
                        <Row.PageTitle title={'Settings'}/>
                </View>}
                <View style={{display:'flex',flexDirection: 'column',width:"100%",flex:1,overflow:'auto'}}>
                {/* <Row.SettingLink         
                title="Add New Tool"
                symbol = {addIcon}
                onPress = {() => {console.log('Add Tool Clicked')}}/> */}
                <Row.SettingLink   
                    title="Account"
                    symbol = {userSmallIcon}
                    onPress = {() => {navigate(`/settings/account`)}}/>
                {/* <Row.SettingLink          
                    title="Appearance"
                    symbol={appearanceIcon}
                    onPress = {() => {}}/> */}
                <Row.SettingLink 
                    title="Troubleshooting"
                    symbol={troubleshootIcon}
                    onPress = {() => {window.open("https://stratus.gitbook.io/stratus")}}/>
                {allSites.tools.length >0?<View>
                    <Row.Section title="Tool Settings"/>
                    {allSites.tools.map((item,index) =>(
                    <Row.SettingLink
                        key = {item.key}
                        symbol = {item.toolType == ToolTypes.THP || item.toolType == ToolTypes.SDP?thpIcon:
                                item.toolType == ToolTypes.ANALOG_4_CH?analogIcon:
                                item.toolType == ToolTypes.THERMO_4_CH?therm4Icon:
                                item.toolType == ToolTypes.SWIM?swimIcon:
                                item.toolType == ToolTypes.CHEM?chemIcon:toolIcon}  
                        title = {item.label}
                        onPress = {() => {
                            navigate('/toolSettings/'+item.key)
                        }}
                    />
                    ))}
                </View>:<></>}
                </View>
            </View>
        )
        if(channel){
            content3 = (
                <View style={{display:'flex',flexDirection: 'column',flex:1,height:'100%'}}>
                    {graphMac?<></>:<View style={{overflow:'none'}}>
                        <Row.PageTitle title={''}/>
                    </View>}
                    <View style={{display:'flex',flexDirection: 'column',width:"100%",flex:1,overflow:'auto',borderLeft:'2px solid',borderLeftColor: Colors.light}}>
                        <Row.Section title="Channel"/>
                        {channel && (!ToolTypes.THP.localeCompare(tool.toolType))?(<THPChannelContainer currentTool ={tool} channelKey = {channel}/>):(<></>)}
                        {channel && (!ToolTypes.SDP.localeCompare(tool.toolType))?(<SDP1ChannelContainer currentTool ={tool} channelKey = {channel}/>):(<></>)}
                        {channel && (!ToolTypes.ANALOG_4_CH.localeCompare(tool.toolType))?(<SA4CChannelContainer currentTool ={tool} channelKey = {channel}/>):(<></>)}
                        {channel && (!ToolTypes.THERMO_4_CH.localeCompare(tool.toolType))?(<ST4CChannelContainer currentTool ={tool} channelKey = {channel}/>):(<></>)}
                        {channel && (!ToolTypes.SWIM.localeCompare(tool.toolType))?(<SSS1ChannelContainer currentTool ={tool} channelKey = {channel}/>):(<></>)}
                        {channel && (!ToolTypes.CHEM.localeCompare(tool.toolType))?(<SCP1ChannelContainer currentTool ={tool} channelKey = {channel}/>):(<></>)}
                    </View>
                </View>
              )
        }else if(window?.location?.pathname.includes('sharePage') || (graphMac && (graphPage == 'sharePage'))){
            content3 = (
                <View style={{display:'flex',flexDirection: 'column',flex:1,height:'100%'}}>
                    {graphMac?<></>:<View style={{overflow:'none'}}>
                        <Row.PageTitle title={''}/>
                    </View>}
                    <View style={{display:'flex',flexDirection: 'column',width:"100%",flex:1,overflow:'auto',borderLeft:'2px solid',borderLeftColor: Colors.light}}>
                        <Row.Section title="Share Tool"/>
                        {!_.isEmpty(senderShares) ? (
                        Array.from(senderShares.values()).map((item, index) => (
                            item.mac==tool.mac?<Row.SenderShare share={item} token={user.signInUserSession.idToken.jwtToken} onDelete={()=>pullSenderShares()}/>:<></>
                        ))) :(<></>)//No channels
                        }    
                        <Row.SettingLink
                        title="Add a member"
                        symbol = {userAddIcon}
                        symbolSize = "s22"
                        onPress = {() => {
                          if(graphMac){
                            setGraphPage('addMember')
                          }else{
                            navigate(mac+'/addMember')
                          }
                        }}/>
                    </View>
                </View>
              )
        }else if(window?.location?.pathname.includes('addMember') || (graphMac && (graphPage == 'addMember'))){
            content3 = (
                <View style={{display:'flex',flexDirection: 'column',flex:1,height:'100%'}}>
                    {graphMac?<></>:<View style={{overflow:'none'}}>
                        <Row.PageTitle title={''}/>
                    </View>}
                    <View style={{display:'flex',flexDirection: 'column',width:"100%",flex:1,overflow:'auto',borderLeft:'2px solid',borderLeftColor: Colors.light}}>
                    <Row.Section title="Add a member"/>
                    <Text color="darkGrey" as="large">{'Enter email to share Tool / Group'}</Text>
                    <Row.AuthInput label="Email Address" icon={emailIcon} value={email} setValue={updateEmail} error={emailError} setError={setEmailError}/>
                    <Text color="error" weight="light">{error}</Text>
                    <Button
                        style={Metrics.smallTopMargin}
                        isLoading = {verifyButtonLoading}
                        disabled = {verified}
                        text="Verify"
                        variant="primary-transparent"
                        onPress={async () => {
                            if(userEmail != email){
                                await setError('')
                                await setVerifyButtonLoading(true)
                                if(await errorCheck()){
                                    try {
                                        let resp = await checkRecipientEmail(user.signInUserSession.idToken.jwtToken,email)
                                        setVerified(resp)
                                    } catch (error) {
                                        console.log(error)
                                        switch(error.code){
                                            default:
                                                await setError(error.message)
                                            break
                                        }
                                    }
                                    await setVerifyInitiated(true)
                                }         
                                await setVerifyButtonLoading(false)  
                            }else{
                                setEmailError("Can't share with yourself")
                            }
                        }}
                    />
                    {verified?<Text color="darkGrey" as="large">{'Email Successfully Verified'}</Text>:
                    verifyInitiated?<Text color="darkGrey" as="large">{'The email entered does not have a Stratus account associated with it'}</Text>:
                    <></>}
                    <Button
                        style={Metrics.smallTopMargin}
                        isLoading = {addLoading}
                        disabled = {!verified}
                        text="Add Member"
                        variant="primary"
                        onPress={() => {
                            setError('')
                            setAddLoading(true)
                            setAddInitiated(true)
                            setAddStatus('')
                        }}
                    />
                    </View>
                </View>
              )
        }else if(window?.location?.pathname.includes('general') || (graphMac && (graphPage == 'general'))){
            content3 = (
                <View style={{display:'flex',flexDirection: 'column',flex:1,height:'100%'}}>
                    {graphMac?<></>:<View style={{overflow:'none'}}>
                        <Row.PageTitle title={''}/>
                    </View>}
                    <View style={{display:'flex',flexDirection: 'column',width:"100%",flex:1,overflow:'auto',borderLeft:'2px solid',borderLeftColor: Colors.light}}>
                        <Row.Section title="Tool Settings"/>
                        <Row.Setting
                            title="Tool Name"
                            icon={toolIcon}
                            setting={toolName}
                            changeSetting={setToolName}
                            setSetting={(value) => updateSettings({ toolName: value.nativeEvent.text })}
                        />
                        <Row.Setting
                            title="Tool Location"
                            icon={locationIcon}
                            setting={toolLocation}
                            changeSetting={setToolLocation}
                            setSetting={(value) => updateSettings({ toolLocation: value.nativeEvent.text })}
                        />
                        <Row.Value
                            title="Tool Type"
                            icon={toolIcon}
                            value={type} />
                        <Row.Value
                            title="Battery Level"
                            icon={
                            batteryLvl==100?battery100Icon:
                            batteryLvl>=80?battery80Icon:
                            batteryLvl>=60?battery60Icon:
                            batteryLvl>=40?battery40Icon:
                            batteryLvl>=20?battery20Icon:
                            batteryLvl>=10?battery10Icon:
                            batteryLowIcon
                            }
                            value={batteryLvl + "%"} />
                        <Row.Value
                            title="Power Source"
                            icon={powerIcon}
                            color={Colors.lightGrey}
                            value={powerSrc} />
                        {mac && _.has(tool,'share_id')?<Row.Value
                            title="Tool Owner"
                            icon={userIcon}
                            color={Colors.lightGrey}
                            value={recipientShares.get(tool.share_id).recipientSettings.senderEmailID} />:<></>}
                    </View>
                </View>
              )
        }else if(window?.location?.pathname.includes('network') || (graphMac && (graphPage == 'network'))){
            content3 = (
                <View style={{display:'flex',flexDirection: 'column',flex:1,height:'100%'}}>
                    {graphMac?<></>:<View style={{overflow:'none'}}>
                        <Row.PageTitle title={''}/>
                    </View>}
                    <View style={{display:'flex',flexDirection: 'column',width:"100%",flex:1,overflow:'auto',borderLeft:'2px solid',borderLeftColor: Colors.light}}>
                        <Row.Section title="Network"/>
                        <Row.Value
                            title="Wi-Fi SSID:"
                            icon={wifiIcon}
                            value={ssid} />
                        {/* <Row.SettingLink         
                            title="Change Wi-Fi Network"
                            symbol = {changeWifiIcon}
                            onPress = {() => 
                            NavigationService.navigate('Modal',
                                        {screen: 'ProvisionNetwork'})
                            }/> */}
                        <Row.Value
                            title="Wi-Fi IP Address:"
                            icon={wifiIcon}
                            value={ip} />
                        {mac && _.has(tool,'mac')?<Row.Value
                            title="MAC Address:"
                            icon={wifiIcon}
                            value={mac} />:<></>}
                    </View>
                </View>
              )
        }else if(window?.location?.pathname.includes('firmware') || (graphMac && (graphPage == 'firmware'))){
            content3 = (
                <View style={{display:'flex',flexDirection: 'column',flex:1,height:'100%'}}>
                    {graphMac?<></>:<View style={{overflow:'none'}}>
                        <Row.PageTitle title={''}/>
                    </View>}
                    <View style={{display:'flex',flexDirection: 'column',width:"100%",flex:1,overflow:'auto',borderLeft:'2px solid',borderLeftColor: Colors.light}}>
                        <Row.Section title="Firmware Upgrade"/>
                        <View style={{...Metrics.topMargin,...Helpers.colCross}}>
        <img style={{height:300,width:300,...Metrics.verticalMargin}} src={Images.toolFirmware} mode='fit'/>
        {updating && startUpdateStatus == 'ok'?
        <View style={{...Helpers.colCenter}}>
          <Spin size="large" />
          {tool.toolSystem.sysPowerState == "Battery" && progress==0?<Text as='large' style={{...Helpers.textCenter}}>{"Firmware Update Requested.\n\nTool is in battery mode and will receive firmware update in "+ Math.max(Math.round(sensorLive.getTimeUntil(tool.nextUpdateTS)/60000),1) +" minute(s) when it connects back to the server. You can tap the button on your tool to connect faster."}</Text>:
          <Text as='large' style={{...Helpers.textCenter}}>{"Your Stratus Tool is updating.\nYou can check back later\n\n" + "Installing Update\n" + progress + "% Completed"}</Text>}
          
          {<Text as='large' style={{...Helpers.textCenter}}>{"\n"+otaState}</Text>}
        </View>:
        otaError != ""?
        <View style={{...Helpers.colCenter,width:"100%"}}>
          <Text as='large' style={{...Helpers.textCenter}} color='error'>{"Error occured during update\n\n"+otaError}</Text>
          <Button
              isLoading = {updateButtonLoading}
              style={{width:"87%", ...Metrics.verticalMargin}}
              text="Update"
              variant="primary"
              onPress={() => {
                setUpdateButtonLoading(true)
                setStartUpdateStatus('inProgress')
              }}
            />
        </View>:
        <View style={{...Helpers.colCenter,width:"100%"}}>
          <Text as='large' style={{...Helpers.textCenter}}>{"Current Firmware No\n" + fwVer +"\n"}</Text>
          {latestVersion==''?<View style={{...Helpers.textCenter}} ><Spin size="large" /></View>:
          latestVersion==fwVer?
          <Text as='large' >{"Firmware is up to date\n"}</Text>:
          latestVersion==undefined?
          <Text as='large' >{"Firmware update not available\n"}</Text>:
          <View style={{width:'100%', borderColor: Colors.light,borderTopWidth:1,...Helpers.textCenter,...Metrics.verticalPadding}}>
            <View style={styles.iconContainer}><Icon svg={updateIcon} color={Colors.light} size='xs' /></View>
            <Text as='large' style={{...Helpers.textCenter}}>{"Update available\n" + "Firmware No. " +latestVersion + "\n" +"\n"+ releaseNotes}</Text>
          </View>}

          {((latestVersion != fwVer) && (latestVersion!="") && (latestVersion!=undefined) && otaState == 'No OTA Status')?(
            <Button
              isLoading = {updateButtonLoading}
              style={{width:"87%", ...Metrics.verticalMargin}}
              text="Update"
              variant="primary"
              onPress={() => {
                setUpdateButtonLoading(true)
                setStartUpdateStatus('inProgress')
              }}
            />
            ):((latestVersion != fwVer) && (latestVersion!="") && (latestVersion!=undefined))?
            <View style={Helpers.textCenter} ><Spin size="large" /></View>:
            (<></>)}
        </View>}
        </View>
                    </View>
                </View>
              )
        }else{
            content3 = <></>
        }
        if(mac && _.has(tool,'share_id') && recipientShares != null && recipientShares.get(mac).recipientSettings.allowSettings != true){
          content2 =<View style={{display:'flex',flexDirection: 'column',flex:1,height:'100%',overflow:'auto'}}>
                    {graphMac?<></>:<View style={{overflow:'none'}}>
                        <Row.PageTitle title={toolName?toolName:''}/>
                    </View>}
                    <View style={{display:'flex',flexDirection: 'column',width:"100%",flex:1,overflow:'auto',borderLeft:graphMac?'0px solid':'2px solid',borderLeftColor: Colors.light}}>
            <Row.Section title="Settings"></Row.Section>
            <Row.SettingLink  
              title="Identify Tool"
              symbol={identifyIcon}
              onPress = {() => setIdentifyTool(true)}/> 
            {mac && _.has(tool,'share_id') && recipientShares != null && recipientShares.get(mac).recipientSettings.allowClearData == false?<></>:
            <Row.SettingLink  
            title="Clear Data"
            symbol={clearIcon}
            onPress = {() => setClearTool(true)}/>}
            <Row.SettingLink 
            title="Remove Shared Tool"
            symbol={deleteIcon}
            color={Colors.lightGrey}
            onPress = {() => setRemoveSharedTool(true)}/>
            <Text style={[Metrics.tinyHorizontalMargin,Helpers.textCenter]}>Access to tool settings not provided. For access, please ask sender to allow Tool Settings in their Share Tool settings.</Text>
          </View>
          </View>
        }else{
          content2 = (
            <View style={{display:'flex',flexDirection: 'column',flex:1,height:'100%',overflow:'auto'}}>
                    {graphMac?<></>:<View style={{overflow:'none'}}>
                        <Row.PageTitle title={toolName?toolName:''}/>
                    </View>}
                    <View style={{display:'flex',flexDirection: 'column',width:"100%",flex:1,overflow:'auto',borderLeft:graphMac?'0px solid':'2px solid',borderLeftColor: Colors.light}}>
                    <Row.Section title="Channels"></Row.Section>
            {/* List all Settings */}
            { !_.isEmpty(channels)? (//
                channelArray.map(([key, val], index) => {//Interate through channels
                {/* Channel Subheading */}
                {(!ToolTypes.THP.localeCompare(tool.toolType))?channelIcon = THP_CHANNEL_ICONS[index]:
                (!ToolTypes.SDP.localeCompare(tool.toolType))?channelIcon = SDP1_CHANNEL_ICONS[index]:
                (!ToolTypes.THERMO_4_CH.localeCompare(tool.toolType))?channelIcon = ST4C_CHANNEL_ICONS[index]:
                (!ToolTypes.ANALOG_4_CH.localeCompare(tool.toolType))?channelIcon = SA4C_CHANNEL_ICONS[index]:
                (!ToolTypes.SWIM.localeCompare(tool.toolType))?channelIcon = SSS1_CHANNEL_ICONS[index]:
                (!ToolTypes.CHEM.localeCompare(tool.toolType))?channelIcon = SCP1_CHANNEL_ICONS(tool)[index]:
                channelIcon = null
                }
                return <View key={key}>
                    
                    {key == undefined || val == undefined?<></>:
                    <Row.SettingLink 
                        first={true}
                        index={index}
                        style={{borderBottomWidth:index==channelArray.length-1?0:1}}
                        symbol={channelIcon}
                        color={channelColors[index]}
                        title={val.name}
                        state= {true}
                        stateValue={_.has(val,"enabled")?val.enabled:tool.settings.controls.sensorEnable}
                        onPress = {() => {
                          if(graphMac){
                            setGraphPage('channel/'+key)
                          }else{
                            navigate(mac+'/channel/'+key,{tool:[tool],channelKey:[key],appHeader:true})
                          }
                        }}/>
                    }
                  </View>
                })
            ) :
              (<></>)//No channels
            }
            <Row.Section title="Logging"></Row.Section>
            <Row.Toggle //Enable/Disable
              title="Log Enable"
              icon = {logIcon}
              value={logEnable}
              toolValue={logEnableTool}
              syncTime={logEnableTime}
              tool = {tool}
              onValueChange={(value) => {
                setLogEnable(value)
                updateSettings({ controls: { sysLogEnable: value } })
                updateLogEnableTime()
              }}
            />
            {logEnable?<View>
              <Row.SettingLink 
                first={true}
                symbol={toolInIcon}
                title="Data Acquisition Rate"
                label={acqMode==4?'Every ' + customAcqVal +' mins':acqOptions[acqMode]}
                value={usbAcqPer}
                toolValue={usbAcqPerTool}
                syncTime={usbAcqPerTime}
                tool = {tool}
                onPress = {() => {showAcqPicker(true)}}>
                  <View style={{paddingBottom:Spacing.md, paddingLeft:Spacing.xxl}}>
                    <AcqPeriodIcon width={'100%'} height={72}/>
                    <Text color='lightGrey' as='small'>Time interval between data acquisitions.</Text>
                  </View>
              </Row.SettingLink>
              <Row.SettingLink 
                first={true}
                symbol={toolOutIcon}
                title="Data Sync to Cloud"
                label={postMode==4?customPostVal +' Acquisitions':postOptions[postMode]}
                value={usbPostFreq}
                toolValue={usbPostFreqTool}
                syncTime={usbPostFreqTime}
                tool = {tool}
                onPress = {() => {showPostPicker(true)}}>
                  <View style={{paddingBottom:Spacing.md, paddingLeft:Spacing.xxl}}>
                    <PostFreqIcon width={'100%'} height={72}/>
                    <Text color='lightGrey' as='small'>Number of acquisitions before data is sent to cloud.</Text>
                  </View>
              </Row.SettingLink>
              <View style={[Helpers.row,{height:Spacing.compWidth}]} gutter="none" sidePadding="md">
                <View style={styles.symbolContainer}>
                  <Icon color={Colors.lightGrey} svg={infoIcon} size="xs" />
                </View>
                <View style={styles.container}>
                  <Text color='lightGrey' as='small'>"Data Acquistion Rate" and "Data Sync to Cloud" have an effect on battery life of the tool.</Text>
                </View>
              </View>
            </View>:<></>}
            <Row.Section title="General"></Row.Section>
            {mac && _.has(tool,'mac')?<Row.SettingLink
              title="Share Tool"
              symbol = {shareIcon}
              onPress = {() => {
                if(graphMac){
                  setGraphPage('sharePage')
                }else{
                  navigate(mac+'/sharePage',{tool:tool})
                }
              }}/>:<></>}
            <Row.SettingLink
              title="Tool Settings"
              symbol = {toolIcon}
              onPress = {() => {
                if(graphMac){
                  setGraphPage('general')
                }else{
                  navigate(mac+'/general',{mac:mac,share_id:mac,appHeader:true})
                }
              }}/>
            <Row.SettingLink 
              title="Network"
              label={_.has(tool,'toolSystem') && _.has(tool.toolSystem,'wifiSSID')?tool.toolSystem.wifiSSID:''}
              symbol = {wifiIcon}
              onPress = {() => {
                if(graphMac){
                  setGraphPage('network')
                }else{
                  navigate(mac+'/network',{mac:mac,share_id:mac,appHeader:true})
                }
              }}/>
            {mac && _.has(tool,'mac')?<Row.SettingLink 
              title="Firmware"
              symbol={firmwareIcon}
              onPress = {() => {
                goingToFirmware = true
                if(graphMac){
                  setGraphPage('firmware')
                }else{
                  navigate(mac+'/firmware',
                                {
                                  mac:mac,
                                  share_id:mac,
                                  appHeader:true})
                }
              }}/>:<></>}
            <Row.SettingLink  
              title="Identify Tool"
              symbol={identifyIcon}
              onPress = {() => setIdentifyTool(true)}/> 
            {mac && _.has(tool,'share_id') && recipientShares != null && recipientShares.get(mac).recipientSettings.allowClearData == false?<></>:
            <Row.SettingLink  
            title="Clear Data"
            symbol={clearIcon}
            onPress = {() => setClearTool(true)}/>}
            {
              mac && _.has(tool,'mac')?<Row.SettingLink 
              title="Delete Tool"
              symbol={deleteIcon}
              color={Colors.lightGrey}
              onPress = {() => setDeleteTool(true)}/>:
              <Row.SettingLink 
              title="Remove Shared Tool"
              symbol={deleteIcon}
              color={Colors.lightGrey}
              onPress = {() => setRemoveSharedTool(true)}/>
            }
            <Row.SettingLink 
              title="User Guide"
              symbol={troubleshootIcon}
              onPress = {
                () => {
                    let uri
                    if(!ToolTypes.THP.localeCompare(tool.toolType)){
                        uri = 'https://stratus.gitbook.io/stratus/tools/sthp'
                    }else if(!ToolTypes.SDP.localeCompare(tool.toolType)){
                        uri = 'https://stratus.gitbook.io/stratus/tools'
                    }else if(!ToolTypes.THERMO_4_CH.localeCompare(tool.toolType)){
                        uri = 'https://stratus.gitbook.io/stratus/tools/st4c'
                    }else if(!ToolTypes.ANALOG_4_CH.localeCompare(tool.toolType)){
                        uri = 'https://stratus.gitbook.io/stratus/tools/sa4c'
                    }else if(!ToolTypes.SWIM.localeCompare(tool.toolType)){
                        uri = 'https://stratus.gitbook.io/stratus/tools'
                    }else if(!ToolTypes.CHEM.localeCompare(tool.toolType)){
                        uri = 'https://stratus.gitbook.io/stratus/tools/scp1'
                    }else{
                        uri = 'https://stratus.gitbook.io/stratus/tools'
                        console.warn("UNDEFINED TOOLTYPE")
                    }
                    window.open(uri)
                }
              }/>
            
                    </View>
                </View>
        )
        }
            {console.log('addStatus:',addStatus)}
    }

    return <View style={{height:graphMac?'calc(100vh - 120px)':'calc(100vh - 50px)',overflow:'clip'}}>
        <View style={[Helpers.row,{height:'100%'}]}>
        {graphMac?<></>:content1}
        {content2}
        {content3}
        <Alert visible={deleteTool} setVisible={setDeleteTool} title="Delete Tool" text={"Are you sure you want to delete this Stratus tool?\n\nThis will not delete any saved logs."} 
              loading = {deleteToolLoading}
              onPress={async ()=>{
                  setDeleteToolLoading(true)
                  setDeleteInitiated(true)
                //   setDeleteToolStatus('')
                }}
            />
            <Alert visible={removeSharedTool} setVisible={setRemoveSharedTool} title="Remove Shared Tool" text={"Are you sure you want to remove this shared Stratus tool?\n\nThis will not delete any saved logs."} 
              loading = {deleteToolLoading}
              onPress={async ()=>{
                  setDeleteToolLoading(true)
                }}
            />
            <Alert 
              visible={clearTool} 
              setVisible={setClearTool} 
              title="Clear Data" 
              text={"Are you sure you want to clear all the data associated with this Stratus tool?\n\nThis will not delete any saved logs."}
              loading = {clearToolLoading}
              onPress={async ()=>{
                setClearToolStatus('')
                setClearToolLoading(true)
              }}
              />
            <Alert 
              visible={identifyTool} 
              setVisible={setIdentifyTool} 
              title="Identify Tool" 
              text={"Continue to identify this tool with flashing LEDs."}
              loading = {identifyToolLoading}
              onPress={async ()=>{
                setIdentifyToolStatus('')
                setIdentifyToolLoading(true)
              }}
              />
            <Alert 
              visible={customPost} 
              setVisible={setCustomPost} 
              title="Data Sync to Cloud" 
              numericInput={"Number of Acquisitions (Min 1 | Max 60)"} 
              defaultValue={value} 
              valueUpdated={valueUpdated}
              min={1}
              max={60}
              onPress={(number)=>{
                setCustomPostVal(number)
                setPostMode(4)
                setUsbPostFreq(number)
                updateSettings({ controls: {sysUSBPostFreq: Number(number),sysBattPostFreq: Number(number) }})
                updateUsbPostFreq()
              }}/>
            <Modal
            title={'Data Sync to Cloud'}
            closeIcon={null}
            open={postPicker}
            footer={null}
            onCancel={() => {
                showPostPicker(false);
            }}
            onOk={() => {
                showPostPicker(false);
            }}
            onClick={(event)=>{
                event.stopPropagation();
                showPostPicker(false);
            }}
        >
            <View onClick={(event)=>{
            event.stopPropagation();
            }}>
            <Radio.Group 
                onChange={(e) => {
                    console.log('radio checked', e.target.value);
                    if (e.target.value == undefined) {

                    } else if (e.target.value == postOptions.length-1) {
                        setValue(customPostVal.toLocaleString())
                        setValueUpdated(true)
                        setCustomPost(true)
                    }else {
                        setPostMode(e.target.value)
                        setUsbPostFreq(postOptionValues[e.target.value])
                        updateSettings({ controls: {sysUSBPostFreq: postOptionValues[e.target.value],sysBattPostFreq: postOptionValues[e.target.value] }})
                        updateUsbPostFreq()
                    }
                    showPostPicker(false);
                }} 
                value={postMode}
            >
                <Space direction="vertical">
                {postOptions.map((item,index) =>(
                    <Radio value={index}>{item}</Radio>
                    ))}
                </Space>
            </Radio.Group>
            </View>
        </Modal>
          <Alert
            visible={customAcq} 
            setVisible={setCustomAcq} 
            title="Data Acquisition Rate" 
            numericInput={"Time in minutes (Min 1 | Max 60)"} 
            defaultValue={value} 
            valueUpdated={valueUpdated}
            min={1}
            max={60}
            onPress={(number)=>{
              setCustomAcqVal(number)
              setAcqMode(4)
              setUsbAcqPer(number*60)
              updateSettings({ controls: {sysUSBAcqPer: Number(number)*60,sysBattAcqPer: Number(number)*60  }})
              updateUsbAcqPer()
            }}/>
          <Modal
            title={'Data Acquisition Rate'}
            closeIcon={null}
            open={acqPicker}
            footer={null}
            onCancel={() => {
                showAcqPicker(false);
            }}
            onOk={() => {
                showAcqPicker(false);
            }}
            onClick={(event)=>{
                event.stopPropagation();
                showAcqPicker(false);
            }}
        >
            <View onClick={(event)=>{
            event.stopPropagation();
            }}>
            <Radio.Group 
                onChange={(e) => {
                    console.log('radio checked', e.target.value);
                    if (e.target.value == undefined) {

                    } else if (e.target.value == acqOptions.length-1) {
                        setValue(customAcqVal.toLocaleString())
                        setValueUpdated(true)
                        setCustomAcq(true)
                    }else {
                        setAcqMode(e.target.value)
                        setUsbAcqPer(acqOptionValues[e.target.value])
                        updateSettings({ controls: {sysUSBAcqPer: acqOptionValues[e.target.value],sysBattAcqPer: acqOptionValues[e.target.value] }})
                        updateUsbAcqPer()
                    }
                    showAcqPicker(false);
                }} 
                value={acqMode}
            >
                <Space direction="vertical">
                {acqOptions.map((item,index) =>(
                    <Radio value={index}>{item}</Radio>
                    ))}
                </Space>
            </Radio.Group>
            </View>
        </Modal>
        <Alert 
        visible={addShare} 
        setVisible={setAddShare} 
        oneButton={true} 
        title={addStatus == true?"Invitation Sent":"Invitation Error" }
        text={addStatus == true?"Invitation has been sent to "+email:(addStatus.errors)}
        onPress = {() => {
          setAddShare(false)
          if(graphMac){
            setGraphPage('sharePage')
          }else{
            navigate(mac+'/sharePage',{tool:tool})
          }
        }}
        />
        </View>
    </View>
}

export default ToolSettings;